import './NewAdClip.sass';

import { FC, useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { adsActions, adsSelector } from '$store/ads';
import { adsActions, adsSelector } from '$store/ads';
import { Loader, MetaTags } from '$shared/components';
import { Button, Header, List, ListItem, Placeholder, ScrollView } from '$uikit';
import { useTranslator } from '$hooks';
import { SUBSCRIPTION_MEDIA } from '$shared/constants/pages';
import { postsSelector } from '$store/posts';
import { adsStatus, format } from '$utils';
import { goBack, showModal } from '$navigation/helper';
import { formatNumber } from '$utils/number';
import { useRouter } from 'react-router5';
import { IcCloud28, IcUpload28 } from '$assets';
import { toastActions } from '$store/toast';
import { attachActions } from '$store/attach';
import { NEW_AD_CLIP_PREVIEW } from '$shared/constants/modals';

export const NewAdClip: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const { loadingStatus, ads, balance } = useSelector(adsSelector);
  const { posts } = useSelector(postsSelector);
  const router = useRouter();

  const handleChooseFromCloud = () => {
    //
  };

  const handleVideoChange = useCallback(
    ({ target }) => {
      if (!target.files.length) {
        return;
      }
      const file = target.files[0];
      const video = document.createElement('video');
      video.src = URL.createObjectURL(file);
      video.onloadedmetadata = () => {
        if (video.duration > 15) {
          return dispatch(toastActions.setToastFail(t('reels_add_long_error')));
        }

        if (video.width > video.height) {
          return dispatch(toastActions.setToastFail(t('reels_add_vertical_error')));
        }

        dispatch(
          attachActions.uploadVideo({
            pickerId: 'reel',
            file,
            dispatch,
          }),
        );
        dispatch(attachActions.setIsAdditionalModalOpened(true));
        showModal(NEW_AD_CLIP_PREVIEW, true);
      };
    },
    [t],
  );

  useEffect(() => {
    dispatch(adsActions.setAdType('reels'));
  }, []);

  return (
    <>
      <MetaTags title={t('new_ad_clip')} />
      <Header showBackButton backButtonOnClick={() => goBack()}>
        {t('new_ad_clip')}
      </Header>

      <div className="NewAdClip">
        <Placeholder
          title={t('new_ad_clip_upload')}
          centered
          actions={
            <div className="NewAdClip__actions">
              <div className="NewAdClip__upload_wrap">
                <Button stretched iconRight={<IcUpload28 />}>
                  {t('new_ad_clip_choose_video')}
                </Button>
                <input
                  type="file"
                  accept="video/*"
                  className="NewReel__upload_input"
                  onChange={handleVideoChange}
                />
              </div>

              <Button
                mode="secondary"
                onClick={handleChooseFromCloud}
                stretched
                iconRight={<IcCloud28 />}
              >
                {t('new_ad_clip_from_cloud')}
              </Button>
            </div>
          }
        >
          {t('new_ad_clip_caption')}
        </Placeholder>
      </div>
    </>
  );
};
